export const SET_LOADED_BRP_SETTINGS = 'setLoadedBrpSettings';
export const SET_HAS_DEFAULT_BRP_SETTING = 'setHasDefaultBrpSettings';
export const SET_LOADED_PRP_SETTINGS = 'setLoadedPrpSettings';
export const SET_HAS_DEFAULT_PRP_SETTING = 'setHasDefaultPrpSettings';